/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_cards_detail_title = /** @type {(inputs: {}) => string} */ () => {
	return `Detalles de la Tarjeta`
};

const en_cards_detail_title = /** @type {(inputs: {}) => string} */ () => {
	return `Card Details`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const cards_detail_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cards_detail_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("cards_detail_title", locale)
	if (locale === "es") return es_cards_detail_title(inputs)
	return en_cards_detail_title(inputs)
};
export { cards_detail_title as "cards.detail.title" }